import React, { useState } from 'react';

const Signup = ({ onSignup, handleSigninModal }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSignup(username, password);
  };

  return (
    <div
      className="container signup-container"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1494859802809-d069c3b71a8a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80')",
        height: '95vh'
      }}
    >
      <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div className="card border-0" style={{ width: '400px', height: '400px', margin: '0 auto', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
          <div className="card-body d-flex flex-column align-items-center justify-content-center">
            <h2 className="card-title text-center mb-4">Signup</h2>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={username}
                  onChange={handleUsernameChange}
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={handlePasswordChange}
                  required
                />
              </div>
              <div className="d-flex justify-content-center">
                <button type="submit" className="btn btn-primary">
                  Signup
                </button>
              </div>
            </form>
            <p className="text-center mt-3 mb-0">
              Already have an account? <button onClick={handleSigninModal} className="btn btn-link p-0" type="button">Signin</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
